<template>
  <div class="sm:relative">
    <input type="hidden" :name="name" v-if="selected.length === 0" />
    <input type="hidden" :name="name" v-for="id in selected" :key="id" :value="id" />

    <options-popout :options="options" v-model="selected">
      {{ title }}
      <template v-slot:dropdown>
        <template v-if="selectedOptions.length === 0">
          {{ $t('contacts.filter.unfiltered') }}
        </template>
        <template v-else>
          {{ $t('contacts.filter.filtered', { count: selectedOptions.length }) }}
        </template>
      </template>
    </options-popout>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    selectedOptions: {
      type: Array,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    currentGet: {
      required: false,
    },
  },
  data() {
    return {
      selected: [],
    }
  },
  mounted() {
    if (this.selectedOptions.length > 0) {
      this.selected = this.selectedOptions
    }
  },
}
</script>
